import { Box, type BoxProps } from '@mui/material';

interface CardImgProps extends Omit<BoxProps<'img'>, 'component'> {
  src: string;
  alt: string;
}

/**
 * Reusable image component for dashboard cards
 * Styled to fill container with proper containment
 */
export const CardImg = ({ src, alt, sx, ...props }: CardImgProps) => {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        objectFit: 'contain',
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        padding: 2,
        objectPosition: 'top',
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...sx,
      }}
      {...props}
    />
  );
};

export default CardImg;
